import { useState, useCallback } from 'react'
import { useCopyToClipboard as useCopyToClipboardHook } from 'react-use'

const useCopyToClipboard = () => {
  const [state, copyToClipboardHook] = useCopyToClipboardHook()
  const [copied, setCopied] = useState(false)

  const copyToClipboard = useCallback(
    (value) => {
      copyToClipboardHook(value)

      setCopied(true)
      
      setTimeout(() => {
        setCopied(false)
      }, 2000)
    },
    [copyToClipboardHook, state]
  )

  return [state, copyToClipboard, copied]
}

export default useCopyToClipboard
